import { Box, IconButton } from "@mui/joy";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export function RemoveFormElementButton({ size, onClick, ...props }) {
  return (
    <Box>
      <IconButton variant="outlined" size={size} onClick={onClick} {...props}>
        <CloseOutlinedIcon />
      </IconButton>
    </Box>
  );
}
